import React from "react";
import { cheq, storage, db, database } from "../../firebaseConfig";
import firebase from "firebase";
import { useState } from "react";
import { useAuthState } from 'react-firebase-hooks/auth';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";
import { Button } from "react-bootstrap";
import { MDCTextField } from "@material/textfield";

import Login from "../../Login";
import ClientDetails from "../components/clientDetails";

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete'; 

import dayjs from "dayjs";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FooterNew from "../../Footers/Footer";

import TnC from "../components/tnc";
import FooterNext from "../../Footers/FooterNext";
import SafeplanTermsAndConditions from "./descrptions/safeplanTermsAndConditions";
import DescriptionVaccinationCamp from "./descrptions/descrptionVaccinationCamp";





export default function Vaccination() {
  // Inputs

  const [user] = useAuthState(cheq);
  
  const [todayDate, setTodayDate] = useState(new Date());
  const [reqDate, setReqDate] = useState(new Date());


  const [cityName, setCityName] = useState("");
  const [headCount, setHeadCount] = useState("");
  const [budgetPP, setBudgetPP] = useState("");

  const [details, setDetails] = useState("");

  const [orgName, setOrgName] = useState("");
  const [orgRepName, setOrgRepName] = useState("");
  const [orgRepDesignation, setRepDesignation] = useState("");
  const [orgRepOfficialEmail, setOrgRepOfficialEmail] = useState("");
  const [orgCompleteAddress, setOrgCompleteAddress] = useState("");



  const cityOptions = [
    { label: 'Bengaluru' },
    { label: 'Delhi' },
    { label: 'Hyderabad' },
    { label: 'Mumbai' },
    { label: 'Pune' },
  ];

  const headCountOptions = [
    { label: 'less than 50' },
    { label: '50-100' },
    { label: '100-500' },
    { label: '500-1000' },
    { label: '1000-5000' },
    { label: 'more than 5000' },
  ];

  const budgetOptions = [
    { label: 'INR 200 - INR 500 per person' },
    { label: 'INR 500 - INR 1000 per person' },
    { label: 'INR 1000 - INR 1500 per person' },
    { label: 'INR 1500 - INR 2000 per person' },
    { label: 'INR 2000 - INR 2500 per person' },
    { label: 'above INR 2500 per person' },
  ];

  function postRequest() {

    if(cityName === ""){
      alert("Please enter City");
      return;
    }

    if(headCount === ""){
      alert("Please enter Head Count (Approx.)");
      return;
    }

    if(budgetPP === ""){
      alert("Please enter budget");
      return;
    }

    if(orgName === "" || orgRepName === "" || orgRepDesignation === "" || orgRepOfficialEmail === "" ||
    orgCompleteAddress === ""){
      alert("Please enter Organization Details");
      return;
    }

    db.collection("vaccination-safeplan").add({

      PosterPhone: cheq.currentUser.phoneNumber,
      city: cityName,
      headCount: headCount,
      budgetPP: budgetPP,

      details: details,
      orgName: orgName,
      orgRepName: orgRepName,
      orgRepDesignation: orgRepDesignation,
      orgRepOfficialEmail: orgRepOfficialEmail,
      orgCompleteAddress: orgCompleteAddress,

      todayDate:todayDate, 
      requestDate: dayjs(reqDate).format('LL'),
      Time: firebase.firestore.Timestamp.now().toDate().toString(),
      
    });

    database.ref("onlinerequest/safeplan/vaccination").push({

      PosterPhone: cheq.currentUser.phoneNumber,
      city: cityName,
      headCount: headCount,
      budgetPP: budgetPP,

      details: details,
      orgName: orgName,
      orgRepName: orgRepName,
      orgRepDesignation: orgRepDesignation,
      orgRepOfficialEmail: orgRepOfficialEmail,
      orgCompleteAddress: orgCompleteAddress,

      todayDate:todayDate, 
      requestDate: dayjs(reqDate).format('LL'),
      Time: firebase.firestore.Timestamp.now().toDate().toString(),

    }).catch(alert);

    window.location.replace('https://rzp.io/l/drplanete-vaccination-plans');
   
    //alert("Request Placed Successfully!!")
    /*alert("city Name - " + cityName + "\n" + headCount + "\n" + budgetPP + "\n" +
    orgName + "\n" + orgRepName + "\n" + orgRepDesignation + "\n" + orgRepOfficialEmail + "\n" + 
    orgCompleteAddress + "\n" + dayjs(todayDate).format('L') + "\n" + dayjs(reqDate).format('LL'));

    */
  }

  return (
    user ? <>
    
    <div>
      <DescriptionVaccinationCamp/>
    <div className="vf-container">
      

      <div className="vf-form-section">
        <div style={{marginBottom:"25px"}}>
        <Autocomplete
          disablePortal
          options={cityOptions}
          onChange={(event, value) => setCityName(value?.label)}
          renderInput={(params) => <TextField {...params} label="Select City" />}
          sx={{ width: "100%", maxWidth: 500 }}
        />
        </div>

        <TextField
          label="Details"
          variant="outlined"
          multiline
          fullWidth
          maxRows={4}
          onChange={(e) => setDetails(e.target.value)}
          className="vf-field"
        />

        <div className="vf-dual-fields">
          <Autocomplete
            disablePortal
            options={headCountOptions}
            onChange={(event, value) => setHeadCount(value?.label)}
            renderInput={(params) => <TextField {...params} label="Head Count" />}
            sx={{ width: "100%", maxWidth: 400 }}
          />

          <Autocomplete
            disablePortal
            options={budgetOptions}
            onChange={(event, value) => setBudgetPP(value?.label)}
            renderInput={(params) => <TextField {...params} label="Budget (Per Head)" />}
            sx={{ width: "100%", maxWidth: 400 }}
          />
        </div>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Date"
            value={reqDate}
            onChange={(newValue) => setReqDate(newValue)}
            renderInput={(params) => <TextField {...params} fullWidth />}
          />
        </LocalizationProvider>
        <p className="vf-date-display">You selected {dayjs(reqDate).format("LL")}</p>
      </div>

      <div className="vf-org-section">
        <TextField label="Organization Name" variant="outlined" fullWidth onChange={(e) => setOrgName(e.target.value)} className="vf-field" />
        <TextField label="Organization Representative Name" variant="outlined" fullWidth onChange={(e) => setOrgRepName(e.target.value)} className="vf-field" />
        <TextField label="Representative Designation" variant="outlined" fullWidth onChange={(e) => setRepDesignation(e.target.value)} className="vf-field" />
        <TextField label="Representative Official Email ID" variant="outlined" fullWidth onChange={(e) => setOrgRepOfficialEmail(e.target.value)} className="vf-field" />
        <TextField label="Organization Address" variant="outlined" multiline fullWidth maxRows={4} onChange={(e) => setOrgCompleteAddress(e.target.value)} className="vf-field" />
      </div>

      
      <SafeplanTermsAndConditions/>
      <div>
        <center>
         <Button variant="primary" size="lg" onClick={postRequest}>Post Request</Button>
         </center>
      </div>
      
    </div>
    <FooterNext />
    </div>
    
    </> : <Login/>
  );
}

const style = document.createElement("style");
style.textContent = `
.vf-container {
  background-color: white;
  padding: 20px;
  font-family: sans-serif;
}

.vf-banner {
  width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: cover;
  margin-bottom: 20px;
}

.vf-form-section,
.vf-org-section,
.vf-note-section {
  margin: 20px auto;
  max-width: 800px;
  padding: 15px;
}

.vf-field {
  margin-top: 20px;
  margin-bottom: 20px;
}

.vf-dual-fields {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 20px 0;
}

@media (min-width: 768px) {
  .vf-dual-fields {
    flex-direction: row;
    justify-content: space-between;
  }
}

.vf-date-display {
  margin-top: 10px;
  font-style: italic;
}

.vf-note-section {
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #f9f9f9;
  padding: 20px;
}

.vf-note-list {
  list-style: decimal inside;
  font-size: 14px;
  margin-bottom: 20px;
}

.vf-terms {
  text-align: center;
  font-weight: bold;
  margin-bottom: 20px;
}
`;
document.head.append(style);